import Vue from 'vue'
import App from './App'
import router from './router'
import Vuecidity from 'vuecidity'
import VueCircleSlider from 'vue-circle-slider'
import VueClipboard from 'vue-clipboard2'
import '../node_modules/vuecidity/dist/lib/vuecidity.min.css'

Vue.use(Vuecidity)
Vue.use(VueCircleSlider)
Vue.use(VueClipboard)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js